import { NavItemProps } from '@components/ui/nav/nav-item';
import { NavSection, NavSectionProps } from '@components/ui/nav/nav-section';
import useResponsive from '@hooks/media-query';
import { Box, Drawer, DrawerProps, Stack } from '@mui/material';
import { FunctionComponent, ReactNode, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export type NavProps = {
  header?: ReactNode;
  onCloseNav: () => void;
  openNav: boolean;
  width: number;
} & Pick<NavSectionProps, 'items'>;

export const Nav: FunctionComponent<NavProps> = (props) => {
  const { header, items, onCloseNav, openNav, width } = props;
  const { pathname } = useLocation();
  const isDesktop = useResponsive({
    query: 'up',
    start: 'lg',
  });

  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const isItemSelected = (item: NavItemProps) => pathname === item.path;

  let drawerProps: DrawerProps = {
    ModalProps: {
      keepMounted: true,
    },
    PaperProps: {
      sx: { width },
    },
    onClose: onCloseNav,
    open: openNav,
  };

  if (isDesktop) {
    drawerProps = {
      PaperProps: {
        sx: {
          borderRightStyle: 'dashed',
          width,
        },
      },
      open: true,
      variant: 'permanent',
    };
  }

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: width },
      }}
    >
      <Drawer {...drawerProps}>
        <Stack direction="column">
          {header && (
            <Box
              sx={{
                display: 'inline-flex',
                margin: '0',
                px: 2.5,
                py: 3,
              }}
            >
              {header}
            </Box>
          )}
          <NavSection items={items} isItemSelected={isItemSelected} />
        </Stack>
      </Drawer>
    </Box>
  );
};
